import { FileItemType } from 'src/api/generated/touring/types';
import { FilesResponseType } from './types';

export const mapFilesResponseType = (
  apiType: FileItemType[]
): FilesResponseType => {
  return apiType.reduce((acc, item) => {
    acc[item.id] = item;
    return acc;
  }, {} as FilesResponseType);
};
